export default __webpack_public_path__ + "static/media/A9204491.1c10a0ac.jpg";